module.exports = "https://coursera_assets.s3.amazonaws.com/images/87602a05d6b80695359dc331f2a745a6.png";